import React from 'react';
import { Clock, RefreshCw, LogOut } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';

const SessionWarningModal = () => {
  const { sessionWarning, extendSession, dismissSessionWarning, signOut } = useAuth();

  if (!sessionWarning) return null;

  const handleSignOut = async () => {
    dismissSessionWarning();
    await signOut();
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={extendSession} />
      <div className="relative bg-white rounded-2xl shadow-xl border border-gray-100 w-full max-w-sm p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-xl bg-amber-50 border border-amber-100 flex items-center justify-center shrink-0">
            <Clock className="h-5 w-5 text-amber-600" />
          </div>
          <div>
            <h3 className="text-base font-bold text-gray-900">Session läuft ab</h3>
            <p className="text-sm text-gray-500">In 5 Minuten wirst du automatisch abgemeldet.</p>
          </div>
        </div>

        <p className="text-sm text-gray-600 mb-5">
          Möchtest du angemeldet bleiben?
        </p>

        <div className="flex gap-3">
          <button
            onClick={extendSession}
            className="flex-1 inline-flex items-center justify-center gap-2 h-10 rounded-xl bg-[#970000] text-white text-sm font-semibold hover:bg-[#7a0000] transition-colors"
          >
            <RefreshCw className="h-4 w-4" />
            Ja, weiter
          </button>
          <button
            onClick={handleSignOut}
            className="flex-1 inline-flex items-center justify-center gap-2 h-10 rounded-xl border border-gray-200 text-gray-700 text-sm font-medium hover:bg-gray-50 transition-colors"
          >
            <LogOut className="h-4 w-4" />
            Abmelden
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionWarningModal;
